export function sanityInputText(texto) {
    try{
        let resultData = texto = texto.replace(/[\p{C}]/gu, '')
        return resultData;
    } catch(e) {
        console.error(`Error, sanityInputText: ${e}`);
        return texto
    }
}